import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import { Mail, ArrowLeft } from "lucide-react";
import { authService } from "../../services/auth";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Message } from "primereact/message"; 
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
export default function ForgotPasswordPage() {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const onSubmit = async (data) => {
    try {
      setIsSubmitting(true);
      await authService.forgotPassword(data.email);
      toast.success("Şifre sıfırlama bağlantısı email adresinize gönderildi");
      navigate("/login");
    } catch (error) {
      toast.error("Bu email adresi ile kayıtlı kullanıcı bulunamadı");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="flex justify-content-center align-items-center min-h-screen bg-gray-100">
      <div className="surface-card shadow-2 p-5 border-round max-w-30rem w-full">
        <div className="flex justify-content-between">
          {/* Geri Dön Butonu */}
          <div className=" ">
            <Button
              label="Giriş sayfasına dön"
              icon={<ArrowLeft className=" " />}
              text
              className=" "
              onClick={() => navigate("/login")}
            />
          </div>
          {/* Üst Bilgilendirme Alanı */}
          <div className="text-center  ">
            <div className="flex justify-content-center align-items-center bg-blue-100 w-3rem h-3rem border-circle mb-3">
              <Mail className="text-blue-600 w-2rem h-2rem" />
            </div>
          </div>
        </div>
        {/* Üst Bilgilendirme Alanı */}
        <div className="text-center mb-4">
          <h2 className="text-2xl font-bold text-gray-900">Şifremi Unuttum</h2>
          <p className="text-600">
            Email adresinizi girin, size şifre sıfırlama bağlantısı gönderelim.
          </p>
        </div>
        {/* Form Alanı */}
        <form onSubmit={handleSubmit(onSubmit)} className="grid gap-3">
          {/* Email Girişi */}
          <div className="  w-12  pt-2 pb-3">
            <IconField iconPosition="left">
              <InputIcon className="pi pi-envelope"> </InputIcon>

              <InputText
                id="berpmmail"
                className="w-full"
                {...register("email", {
                  required: "Email adresi gerekli",
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                    message: "Geçersiz email adresi",
                  },
                })}
                placeholder="ornek@firma.com"
              />
            </IconField>

            {errors.email && (
              <Message
                severity="error"
                text={errors.email.message}
                className="mt-2 w-12"
              />
            )}
          </div>
          {/* Gönder Butonu */}
          <Button
            type="submit"
            label={isSubmitting ? "" : "Şifre Sıfırlama Bağlantısı Gönder"}
            icon={isSubmitting && "pi pi-spin pi-spinner"}
            className="w-full "
            disabled={isSubmitting}
          />
        </form>
      </div>
    </div>
  );
}
